import React, { useEffect } from 'react'
import { loader } from 'graphql.macro';
import { useQuery } from 'react-apollo';
import GpaPolicyInfo from './gpaPolicyInfo';
import BounceLoaderComponent from './Loader';
import AlertLoader from './AlertLoader';

const get_cancel_policy_info = loader(
  './graphql/Get_Cancel_Policy_Info.graphql'
);

interface PolicyInfoBoxProps {
  accountNumber: string;
  policyNumber: string;
  sourceSystemCode: string;
  environment: string;
}

const PolicyInfoBox = ({
  accountNumber,
  policyNumber,
  sourceSystemCode,
  environment,
} : PolicyInfoBoxProps) => {

  const cancelPolicyInfoResult = useQuery(get_cancel_policy_info, {
    variables: {
      "account_number": accountNumber,
      "directPCCall": true,
      "query_env": environment,
      "policy_number": policyNumber,
      "source_system_code": sourceSystemCode,
    },
    fetchPolicy: 'network-only'
  });
  const { data, loading: dataLoading, error: dataError } = cancelPolicyInfoResult;

  // if (dataLoading) {
  //   return <BounceLoaderComponent />
  // }

  // if ( dataLoading) {
  //   return (
  //     <>
  //       {dataLoading && <AlertLoader message="Please wait..." />}
  //     </>
  //   )
  // }

  if (dataError) {
    console.error('Error fetching policy data:', dataError);
    return <div>Error fetching policy data</div>;
  }

  return (
    <>
      {data && data?.valid_policy_cancellation && data?.valid_policy_cancellation?.data ? (
        <GpaPolicyInfo
        dataLoading={dataLoading}
        result={JSON.parse(data?.valid_policy_cancellation?.data)} />
      ) : (<></>)}
    </>
  )
}

export default PolicyInfoBox